<template>
  <div id="app">
    <a-spin :spinning="getLoading">
      <a-config-provider :locale="localData[locale]">
        <router-view />
      </a-config-provider>
    </a-spin>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import koKR from 'ant-design-vue/lib/locale-provider/ko_KR';
import jaJP from 'ant-design-vue/lib/locale-provider/ja_JP';
export default {
  data() {
    return {
      locale: localStorage.getItem('lang') || 'en-US',
      localData: {
        'zh-CN': zhCN,
        'en-US': enUS,
        'ko-KP': koKR,
        'ja-JP': jaJP,
      }
    }
  },
  computed: {
    getLoading() {
      return this.$store.state.loading
    }
  },
  created() {
    // // console.log('localData[locale] :>> ', this.localData[this.locale]);

    // this.$message.error({
    //   content: '1',
    //   duration: 100000
    // })

    const token = localStorage.getItem('token');
    if (token) {
      this.$store.dispatch('storeActionUserInfo');
      this.$store.dispatch('storeActionAssetsList');
      // this.$store.dispatch('storeActionReturnWallet');
      // this.$store.dispatch("storeSocketConnect");
    }

  }
}
</script>

<style>
@import url(./common/common.scss);


html {
  --primary: #FF8F00;
  --navbar: #fff;
  --border: #E8EDF2;
  --labelColor: #8b8b93;
  --gray: #7e7e8f;
  --tip: #99A1B7;
  --bg: #1f2128;
  --ft: #8083a3;
  --input: #313442;
  --hover: #0f0f12;
}

#app {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #020102;
  background-image: url(@/assets/jf_bg.jpg);
  background-repeat: no-repeat;
  background-size: 100% auto;
  color: #f1f1f1;
}

div {
  box-sizing: border-box;
}

.ant-card {
  border-radius: 5px !important;
  margin-bottom: 15px !important;
  background: transparent !important;
}

.pagination {
  padding: 15px 0;
  text-align: right;
}

.ant-card-head {
  border-bottom: 0 !important;
}

.ant-card-head-title {
  height: 70px;
  padding: 0 !important;
  font-weight: bold !important;
  display: flex !important;
  align-items: center;
  color: #fff;
}

.ant-card-body {
  padding-top: 0 !important;
  color: #fff !important;
}

.ant-form-item-label > label {
  color: #fff !important;
}


.ant-input {
  width: 100%;
  color: var(--gray) !important;
  border-radius: 5px !important;
  background-color: var(--input) !important;
  border-color: var(--labelColor) !important;

  &::-webkit-input-placeholder {
    font-size: 12px;
  }
}

.ant-select-selection {
  background-color: var(--bg) !important;
  border:1px solid var(--input) !important;
}

.ant-select-selection-selected-value {
  color: #fff;
  font-size: 14px;
}

.ant-input-password-icon {
  color: var(--ft);
}

.ant-select-arrow {
  color: #fff !important;
}

.ant-modal-header {
  background-color: var(--bg) !important;
  color: #fff !important; 
  border-bottom: 0 !important;
}

.ant-modal-title {
  background-color: var(--bg) !important;
  color: #fff !important; 
  font-size: 24px !important;
  font-weight: bold !important;
  line-height: 40px !important;
}

.ant-modal-content {
  background-color:  var(--bg) !important;
  opacity: 0.99 !important;
  border-radius: 15px !important;
  filter: blur(92.5) !important;
  color: #fff !important;
}

.ant-modal-close-icon {
  color: #fff !important;
}

.terms {
  font-size: 12px;
  color: #fff;
  line-height: 12px;
}

.ant-select-dropdown {
  background-color: #fff !important;
  color: #000 !important;
}

.ant-select-dropdown-menu-item-selected {
  background-color: #fff !important;
  color: #000 !important;
}

.ant-select-dropdown-menu-item {
  color: #000 !important;
}

.ant-dropdown-link {
  color: #000;
}

.ant-btn-primary {
  height: 35px !important;
  background: #FF8F00 !important;
  color: #fff !important;
  border-radius: 99px !important;
  border-color: var(--primary) !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #FFFF00 !important;

  &::after {
    border-color: #000;
  }
}

.ant-pagination-item-active a{
  color: var(--gray) !important;
}

@media screen and (max-width: 576px) {
  #app {
    padding: 0;
  }

  .ant-card-head-title {
    height: auto;
    padding: 10px 0 !important;
    line-height: 40px;
  }

  .terms {
    font-size: 10px;
    line-height: 12px;
  }
}
</style>
